import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteES() {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function deleteES(esID) {
    return privateFetch.delete(`/v1/admin/es/${esID}`);
  }

  return useMutation(deleteES, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries('ES');
    },
  });
}

export default useDeleteES;
